import { createSlice } from '@reduxjs/toolkit';

import { CONNECTION_STATUS } from '~/renderer/store/connection/types';

import type { CaseReducer, PayloadAction } from '@reduxjs/toolkit';
import type {
  ConnectionError,
  ConnectionState,
  ConnectionStatusType,
  CustomerConnectionStatusType,
} from '~/renderer/store/connection/types';

const initialState: ConnectionState = {
  channelName: '',
  channelNameCustomer: '',
  ablyStatus: CONNECTION_STATUS.DISCONNECTED,
  ablyCustomerStatus: CONNECTION_STATUS.DISCONNECTED,
  localServerStatus: CONNECTION_STATUS.DISCONNECTED,
  error: null,
};

const updateAblyConnectionStatus: CaseReducer<
  ConnectionState,
  PayloadAction<{ status: ConnectionStatusType; error?: ConnectionError }>
> = (state, action) => {
  const { status, error } = action.payload;
  state.ablyStatus = status;
  state.error = error || null;
};

const updateAblyCustomerConnectionStatus: CaseReducer<
  ConnectionState,
  PayloadAction<{ status: CustomerConnectionStatusType; error?: ConnectionError }>
> = (state, action) => {
  const { status } = action.payload;
  state.ablyCustomerStatus = status;
};

const updateLocalServerConnectionStatus: CaseReducer<
  ConnectionState,
  PayloadAction<ConnectionStatusType>
> = (state, action) => {
  state.localServerStatus = action.payload;
};

const updateConnectionError: CaseReducer<ConnectionState, PayloadAction<ConnectionError>> = (
  state,
  action,
) => {
  state.error = action.payload;
};

const updateConnectionChannelName: CaseReducer<ConnectionState, PayloadAction<string>> = (
  state,
  action,
) => {
  state.channelName = action.payload;
};

const updateConnectionChannelNameCustomer: CaseReducer<ConnectionState, PayloadAction<string>> = (
  state,
  action,
) => {
  state.channelNameCustomer = action.payload;
};

const connectionSlice = createSlice({
  name: 'connection',
  initialState,
  reducers: {
    updateAblyConnectionStatus,
    updateConnectionError,
    updateConnectionChannelName,
    updateLocalServerConnectionStatus,
    updateAblyCustomerConnectionStatus,
    updateConnectionChannelNameCustomer,
  },
});

const { actions, reducer } = connectionSlice;

export { reducer as connectionReducer, actions as connectionActions };
